// Reason, weird mix of node and non-node enviroment variables.
/* eslint-disable @typescript-eslint/no-explicit-any */

import { Injectable, Scopes } from '@visiba/instantiation';

interface AnalyticMeta {
	url: string;
	siteId: number;
}

interface AnalyticConfigPresent {
	enabled: true;
	meta: Readonly<AnalyticMeta>;
}

interface AnalyticConfigDisabled {
	enabled: false;
	meta: null;
}

type AnalyticConfig = AnalyticConfigPresent | AnalyticConfigDisabled;

interface Environment {
	api: {
		uri: string | null;
	};
	realtime: {
		host: string | null;
		port: string;
	};
	analyticConfig: AnalyticConfig;
	serverBaseUrl: string;
	cdn: {
		customer: string;
		media: string;
	};
}

@Injectable({
	scope: Scopes.Singleton,
})
export class HostingService {
	public wsBaseUri: string;
	public apiBaseUri: string;
	public readonly assetPath: string;
	public readonly mediaCdn: string;
	public readonly customerCdn: string;
	public readonly location: string;
	public readonly analyticConfig: AnalyticConfig;

	constructor() {
		const VITE_BASE_RULE = '/PublicV3/assets';

		const config: Environment = {
			api: {
				uri: null,
			},
			realtime: {
				host: null,
				port: '443',
			},
			analyticConfig: this.getAnalyticConfig(),
			serverBaseUrl: VITE_BASE_RULE,
			cdn: {
				customer: '//customer-cdn.visibacare.com',
				media: '//media-cdn.visibacare.com',
			},
		};

		this.location = config.api.uri ?? globalThis.location.origin;
		this.assetPath = config.serverBaseUrl;
		this.mediaCdn = config.cdn.media;
		this.customerCdn = config.cdn.customer;
		this.apiBaseUri = `${this.location ?? ''}/api`;
		this.wsBaseUri = `wss://${location.hostname}`;
		this.analyticConfig = config.analyticConfig;
	}

	private getAnalyticConfig(): AnalyticConfig {
		let siteId: number;

		if (!location.hostname) {
			// For usages in test.
			return {
				enabled: false,
				meta: null,
			};
		}

		if (
			location.hostname.includes('vcare.pl') ||
			location.hostname.includes('stage-service.visibacare') ||
			location.hostname.includes('stage-patch.visibacare')
		) {
			siteId = 7; // 7 == New patient web (DEV) siteId in Matomo
		} else {
			siteId = 12; // 12 == New patient web (Prod) siteId in Matomo
		}

		return {
			enabled: true,
			meta: {
				url: '//analytics.visibacare.com/',
				siteId: siteId,
			},
		};
	}
}
